module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("P")]), _vm._v("entecostals have a reputation of being either otherworldly and mystical or aggressively worldly and political: they speak in tongues and dance in the Spirit, in seeming obliviousness to reason and utility, or they work and pray for the kingdom now, marked by health and fame, opulence and worldly power. For the outsiders, it is sometimes hard to imagine that there are forms of Pentecostalism with a very different face. In this book, which bears all the marks of very wide reading, Daniela C. Augustine presents Pentecostalism engaged for the common good and committed to peacebuilding, Pentecostalism open to people from diverse cultures and, in a sense, like the disciples on the Day of Pentecost, speaking diverse “ethno-cultural” languages.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Much of Augustine’s work is rooted in the experiences of Pentecostal Christians in the part of Croatia called East Slavonia. The capital of East Slavonia is Osijek, the town in which I was born and where my father started his ministry; that’s also where my brother-in-law, Peter Kuzmič, was both a minister and an educator and where I had my first teaching job as a young theologian. Ours was Pentecostalism open to the world, a Pentecostalism that stressed learning and social engagement no less than evangelism and healing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Augustine celebrates this brand of Pentecostalism; the accounts of saintly lives from that region make visible “the life of God in flesh” and are the story behind her theoretical text. But she does more than just celebrate lives, and what she does is unique and important: she articulates this open version of Pentecostalism with the help of resources that come from Eastern Orthodoxy (and a good deal of French philosophy!). "), _c('i', [_vm._v("The Spirit and the Common Good")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("is a creative and compelling contribution to the growing body of global Pentecostal theology. Its author is one of today’s most learned and creative Pentecostal theologians.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "CE"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IROSLAV")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLF")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Henry B. Wright Professor of Theology,"), _c('br'), _vm._v("Yale University")]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Founder and Director of Yale Center for"), _c('br'), _vm._v("Faith and Culture")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4203ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 69
// module chunks = 0